module.exports = __webpack_public_path__ + "img/landingpage.33ee3b6d.svg";